import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { EncryptionService } from 'src/app/services/encryption.service';
import { ModerationService } from 'src/app/services/moderation.service';

@Injectable({
  providedIn: 'root'
})
export class HasEnCoursGuard implements CanActivate {

  constructor(private router: Router, private moderationService: ModerationService,private encryptService:EncryptionService){}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot, ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      let user = JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));

      //=> On vérifie si l'operateur a une modération ou un cq en cours
      this.moderationService.checkIfHasEnCours(user.matricule).subscribe((value) => {
        if(value["status"] !== "success"){
          console.log("Une erreur dans la requête:" + value["cause"]);
        }else {
          let result = value['data'];

          if(result.length > 0) {
            
            //=> si c'est en cours de modération
            if(result[0]['id_etat'] === 2 || result[0]['id_etat'] === 8 || result[0]['id_etat'] === 11 ) this.router.navigate(["traitement", (result[0]['id_moderation'])]); 
              
            //=> si c'est en cours de cq
            if(result[0]['id_etat'] === 4 || result[0]['id_etat'] === 14 || result[0]['id_etat'] === 18) this.router.navigate(["cq", (result[0]['id_moderation'])]); 

            if(result[0]['id_etat'] === 9 ) { ///=> si brouillon simple enregistré 

              let options = {
                moderation : result[0]['id_moderation'],
                operateur : user.matricule,
                action : 1,
                etat : 9
              };
          
              
              this.moderationService.changerEtat(options).subscribe(value => {
                if(value["status"] !== "success"){
                  console.log("Une erreur dans la requête:" + JSON.stringify(value["data"]));
                  if(value["data"] === "PTL déjà pris") {
                    alert("déjà pris");
                  }
                } else {
                  this.router.navigate(["/traitement", (result[0]['id_moderation'])] );
                }
              });

            }

            if(result[0]['id_etat'] === 12 ) { ///=> si brouillon simple enregistré CQ 

              let options = {
                moderation : result[0]['id_moderation'],
                operateur : user.matricule,
                action : 4,
                etat : 12
              };
          
              
              this.moderationService.changerEtat(options).subscribe(value => {
                if(value["status"] !== "success"){
                  console.log("Une erreur dans la requête:" + JSON.stringify(value["data"]));
                  if(value["data"] === "PTL déjà pris") {
                    alert("déjà pris");
                  }
                } else {
                  this.router.navigate(["/traitement", (result[0]['id_moderation'])] );
                }
              });

            }


            return false;
          }
  
        }
      });
      
    return true;
  }
  
}
